import { id } from "./id";

type ProjectExpenseType = {
  uuid: string;
  color: string;
  name: string;
};

const projectExpenseType: ProjectExpenseType = {
  uuid: id,
  color: "#000",
  name: "",
};

export type { ProjectExpenseType };

export { projectExpenseType };
